import styled from 'styled-components';


export default styled.main`
  padding: 4rem;

  .title {
    font-family: var(--font-family-alt);
    font-weight: var(--font-weight-bold);
    text-transform: uppercase;
    font-size: 3rem;
    color: var(--color-rojo);
    margin-bottom: .5rem;
  }
  .subtitle {
    font-weight: var(--font-weight-bold);
    text-transform: uppercase;
    font-size: 1.5rem;
    color: var(--color-secondary);
    margin-bottom: 3rem;
  }


  .reg-logo{
    border-color:var(--color-rojo);
    position: relative;
    text-align: center;
    margin-bottom: -65px;
    & img{
        padding: 15px;
        // background-color: #dedede;
    }
  }

  .aviso-priv{
    position:absolute;
    bottom:5px;
    width:100%;
    text-align:0px;
    left:0px;
    right:0px;
  }

`